<template>
  <div class="app-main-inner batch_page">
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <el-form label-width="60px" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_DataType')">
          <el-checkbox v-model="cbJobSelected" no="Business" :disabled="!this.cbJobEnabled">{{ $t('CargoMsg.Cargo_Business') }}</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="cbInvoiceReceivableSelected" no="cbInvoiceReceivableSelected" :disabled="!this.cbInvoiceReceivableEnabled">{{ $t('CargoMsg.Cargo_ARInvoice') }}</el-checkbox>
          <el-checkbox v-model="cbInvoicePayableSelected" no="cbInvoicePayableSelected" :disabled="!this.cbInvoicePayableEnabled">{{ $t('CargoMsg.Cargo_APInvoice') }}</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="cbBillingReceivableSelected" no="cbBillingReceivableSelected" :disabled="!this.cbBillingReceivableEnabled">{{ $t('CargoMsg.Cargo_ARBill') }}</el-checkbox>
          <el-checkbox v-model="cbBillingPayableSelected" no="cbBillingPayableSelected" :disabled="!this.cbBillingPayableEnabled">{{ $t('CargoMsg.Cargo_APBill') }}</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="cbBillingOverseaSelected" no="cbBillingOverseaSelected" :disabled="!this.cbBillingOverseaEnabled">{{ $t('CargoMsg.Cargo_InternationalBill') }}</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="cbReceivableInlandSelected" no="cbReceivableInlandSelected" :disabled="!this.cbReceivableInlandEnabled">{{ $t('CargoMsg.Cargo_DomesticCollection') }}</el-checkbox>
          <el-checkbox v-model="cbPayableInlandSelected" no="cbPayableInlandSelected" :disabled="!this.cbPayableInlandEnabled">{{ $t('CargoMsg.Cargo_DomesticPayment') }}</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="cbReceivableOverseaSelected" no="cbReceivableOverseaSelected" :disabled="!this.cbReceivableOverseaEnabled">{{ $t('CargoMsg.Cargo_OverseasCollection') }}</el-checkbox>
          <el-checkbox v-model="cbPayableOverseaSelected" no="cbPayableOverseaSelected" :disabled="!this.cbPayableOverseaEnabled">{{ $t('CargoMsg.Cargo_OverseasPayment') }}</el-checkbox>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_BusinessDate')" class="el-form-item-search">
          <el-col :span="9">
            <el-date-picker
              v-model="startDate"
              no="startDate"
              type="date"
              :clearable="false"
              value-format="yyyy-MM-dd"
              :editable="false"
              :picker-options="pickerOptionsStartDate"
            />
          </el-col>
          <el-col :span="2"><span>{{ $t('CargoMsg.Cargo_To') }}</span></el-col>
          <el-col :span="9">
            <el-date-picker
              v-model="endDate"
              no="endDate"
              type="date"
              clearable
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsEndDate"
            />
          </el-col>
        </el-form-item>
        <el-form-item style="padding-top: 10px;padding-bottom: 240px;">
          <el-checkbox v-model="isExport" no="isExport">{{ $t('CargoMsg.Cargo_CreateAndExportDirectly') }}</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import moment from 'moment'

export default {
  name: 'BatchPage',
  props: {
    accountSet: { type: Object } // 账套
  },
  data() {
    return {
      startDate: moment().startOf('month').format('yyyy-MM-DD'), // 开始日期
      endDate: null, // 结束日期
      isExport: false, // 是否导出
      pickerOptionsStartDate: {
        disabledDate: this.disabledDateStartDate
      },
      pickerOptionsEndDate: {
        disabledDate: this.disabledDateEndDate
      },
      cbJobEnabled: this.hasRule(FinanceInterfaceConstants.BIZ_REVENUE.code) || this.hasRule(FinanceInterfaceConstants.BIZ_COST.code) || this.hasRule(FinanceInterfaceConstants.BIZ_COST_REVENUE.code),
      cbJobSelected: this.hasRule(FinanceInterfaceConstants.BIZ_REVENUE.code) || this.hasRule(FinanceInterfaceConstants.BIZ_COST.code) || this.hasRule(FinanceInterfaceConstants.BIZ_COST_REVENUE.code),
      cbInvoiceReceivableEnabled: this.hasRule(FinanceInterfaceConstants.INVOICE_RECEIVABLE.code),
      cbInvoiceReceivableSelected: this.hasRule(FinanceInterfaceConstants.INVOICE_RECEIVABLE.code),
      cbInvoicePayableEnabled: this.hasRule(FinanceInterfaceConstants.INVOICE_PAYABLE.code),
      cbInvoicePayableSelected: this.hasRule(FinanceInterfaceConstants.INVOICE_PAYABLE.code),
      cbBillingReceivableEnabled: this.hasRule(FinanceInterfaceConstants.BILLING_RECEIVABLE.code),
      cbBillingReceivableSelected: this.hasRule(FinanceInterfaceConstants.BILLING_RECEIVABLE.code),
      cbBillingPayableEnabled: this.hasRule(FinanceInterfaceConstants.BILLING_PAYABLE.code),
      cbBillingPayableSelected: this.hasRule(FinanceInterfaceConstants.BILLING_PAYABLE.code),
      cbBillingOverseaEnabled: this.hasRule(FinanceInterfaceConstants.BILLING_OVERSEA.code),
      cbBillingOverseaSelected: this.hasRule(FinanceInterfaceConstants.BILLING_OVERSEA.code),
      cbReceivableInlandEnabled: this.hasRule(FinanceInterfaceConstants.RECEIPT_INTERNAL.code),
      cbReceivableInlandSelected: this.hasRule(FinanceInterfaceConstants.RECEIPT_INTERNAL.code),
      cbPayableInlandEnabled: this.hasRule(FinanceInterfaceConstants.PAYMENT_INTERNAL.code),
      cbPayableInlandSelected: this.hasRule(FinanceInterfaceConstants.PAYMENT_INTERNAL.code),
      cbReceivableOverseaEnabled: this.hasRule(FinanceInterfaceConstants.RECEIPT_FOREGIN.code),
      cbReceivableOverseaSelected: this.hasRule(FinanceInterfaceConstants.RECEIPT_FOREGIN.code),
      cbPayableOverseaEnabled: this.hasRule(FinanceInterfaceConstants.PAYMENT_FOREGIN.code),
      cbPayableOverseaSelected: this.hasRule(FinanceInterfaceConstants.PAYMENT_FOREGIN.code)
    }
  },
  methods: {
    hasRule(type) {
      let has = false
      for (const rule of this.accountSet.accountingDocumentsRule) {
        if (rule.businessDataType === type) {
          has = true
          break
        }
      }
      return has
    },
    // 获取选择的分录
    bizTypes() {
      const bizTypes = []
      if (this.cbJobSelected) bizTypes.push(FinanceInterfaceConstants.BIZ_COST.code)
      if (this.cbInvoiceReceivableSelected) bizTypes.push(FinanceInterfaceConstants.INVOICE_RECEIVABLE.code)
      if (this.cbInvoicePayableSelected) bizTypes.push(FinanceInterfaceConstants.INVOICE_PAYABLE.code)
      if (this.cbBillingReceivableSelected) bizTypes.push(FinanceInterfaceConstants.BILLING_RECEIVABLE.code)
      if (this.cbBillingPayableSelected) bizTypes.push(FinanceInterfaceConstants.BILLING_PAYABLE.code)
      if (this.cbBillingOverseaSelected) bizTypes.push(FinanceInterfaceConstants.BILLING_OVERSEA.code)
      if (this.cbReceivableInlandSelected) bizTypes.push(FinanceInterfaceConstants.RECEIPT_INTERNAL.code)
      if (this.cbPayableInlandSelected) bizTypes.push(FinanceInterfaceConstants.PAYMENT_INTERNAL.code)
      if (this.cbReceivableOverseaSelected) bizTypes.push(FinanceInterfaceConstants.RECEIPT_FOREGIN.code)
      if (this.cbPayableOverseaSelected) bizTypes.push(FinanceInterfaceConstants.PAYMENT_FOREGIN.code)
      return bizTypes
    },
    // 验证
    validate() {
      if (this.bizTypes().length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataTypeToCreate'))
        return false
      } else if (!this.startDate && !this.endDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSSDOCD'))
        return false
      }
      return true
    },
    disabledDateStartDate(time) {
      if (this.endDate) {
        return moment(time.getTime()).format('yyyy-MM-DD') > moment(this.endDate).format('yyyy-MM-DD')
      }
      return false
    },
    disabledDateEndDate(time) {
      if (this.startDate) {
        return moment(time.getTime()).format('yyyy-MM-DD') < moment(this.startDate).format('yyyy-MM-DD')
      }
      return false
    }
  }
}
</script>

<style lang="scss">
.batch_page {
  .el-form-item-search {
    width: 400px;
    .el-form-item__content {
      .el-input {
        width: 120px;
      }
      .el-input__inner {
        width: 120px;
      }
    }
  }
}
</style>
